export const PAGE_TYPE = 'AMC Insights';

// Drip Drop's AMC instance — used for the `tinuititest` company so AMC Insights can be
// exercised without a real client instance (mirrors bpm-frontend's Insights page).
export const AMC_TEST_INSTANCE_ID = 'amcgqfnthsb';

// Experiment-gated tab, gated by the `enableAmcPathingAnalysis` experiment rather than by report
// availability like the tabs below.
export const CATEGORY_PATHING_KEY = 'category-pathing';

// Report-gated tab (see `availableTabs` in AmcInsights.tsx), rather than experiment-gated like
// Category Pathing.
export const AUDIENCE_PENETRATION_KEY = 'audience-penetration';

// Report-gated tab — same gating as Geo/New to Brand.
export const MEDIA_MIX_KEY = 'media-mix';

// Report-gated tab — same gating as Media Mix/New to Brand.
export const GEO_KEY = 'geo';

// Admin-only tab — gated by `adminOnly` below rather than by report availability.
export const TABLEAU_KEY = 'tableau';

// Report-gated tab — same gating as Geo/Media Mix.
export const NEW_TO_BRAND_KEY = 'new-to-brand';

export const PATHING_ANALYSIS_KEY = 'pathing-analysis';

// Report-gated tab — same gating as Geo/Media Mix/New to Brand. Backing report type is a guess
// pending the bpa_delivery_metrics_ltv_report/bpa_blended_ltv_report/bpa_cohort_ltv_report
// queries; update once the real report type is known.
export const NTB_LTV_KEY = 'ntb-ltv';

export interface AmcInsightsTab {
  key: string;
  label: string;
  // Raw `reportType` from /getAmcReports that unlocks the tab — a report-gated tab only shows
  // when the client's AMC instance has a report of that type. Omitted for tabs gated another way.
  reportType?: string;
  // Tableau is admin-only in bpm-frontend; mirror that here so the tab bar matches.
  adminOnly?: boolean;
}

// Mirrors bpm-frontend's AMC Insights tab bar so the shell looks continuous regardless of which
// tab is selected. Tableau is listed first (rather than last, where bpm-frontend puts it):
// unlike the report-gated tabs below, it doesn't wait on the async `getAmcReports` fetch, so it's
// available immediately on mount. Putting it first means it renders once and stays put as the
// report-gated tabs pop in around it, instead of visibly jumping from the end of the bar to
// wherever it lands once the rest are known.
export const AMC_INSIGHTS_TABS = [
  { key: TABLEAU_KEY, label: 'Tableau', adminOnly: true },
  { key: GEO_KEY, label: 'Geo', reportType: 'geo' },
  { key: MEDIA_MIX_KEY, label: 'Media Mix', reportType: 'media_mix' },
  { key: NEW_TO_BRAND_KEY, label: 'New to Brand', reportType: 'new_to_brand' },
  { key: PATHING_ANALYSIS_KEY, label: 'Pathing Analysis', reportType: 'pathing_analysis' },
  { key: NTB_LTV_KEY, label: 'NTB Performance & LTV', reportType: 'ntb_ltv' },
  { key: CATEGORY_PATHING_KEY, label: 'Category Pathing' },
  {
    key: AUDIENCE_PENETRATION_KEY,
    label: 'Audience Penetration',
    reportType: 'audience_penetration'
  }
] as const satisfies readonly AmcInsightsTab[];

export type AmcInsightsTabKey = (typeof AMC_INSIGHTS_TABS)[number]['key'];
